export default __webpack_public_path__ + "static/media/logo-exec.7f37a234.png";